import React from 'react';

export default function ReviewCard({ title, rows = [], className = '' }) {
  return (
    <section className={`cc-tonal-panel-soft p-4 ${className}`}>
      <h3 className="mb-2 text-sm font-semibold text-[#e7f0fa]">{title}</h3>
      <div className="space-y-1.5 text-sm">
        {rows.map((row) => (
          <div key={row.label} className="flex items-start justify-between gap-3">
            <span className="text-[11px] font-semibold uppercase tracking-[0.08em] text-[#7f93ac]">{row.label}</span>
            <span className="text-right text-[#d5e4f4]">{row.value || '-'}</span>
          </div>
        ))}
      </div>
    </section>
  );
}
